<dp-my-account-ui
  [node]="(myAccountNode$ | async)"
  [ngClass]="(styleClass$ | async) ?? ''"
  [navAriaLabel]="name$ | async"
></dp-my-account-ui>
